<template>
	<svg version="1.1" id="Layer_1"
		 xmlns="http://www.w3.org/2000/svg"
		 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
		 width="20px" height="20px" viewBox="0 0 20 20"
		 style="enable-background:new 0 0 20 20;"
		 xml:space="preserve">
															<path class="st0" fill="#FFFFFF"
																  d="M16.443,0H3.557C1.595,0,0,1.595,0,3.557v12.888C0,18.405,1.595,20,3.557,20h12.887 C18.404,20,20,18.405,20,16.444V3.557C20,1.595,18.404,0,16.443,0z M18,16.444C18,17.302,17.302,18,16.443,18H3.557 C2.698,18,2,17.302,2,16.444V3.557C2,2.698,2.698,2,3.557,2h12.887C17.302,2,18,2.698,18,3.557V16.444z"/>
		<path class="st0" fill="#FFFFFF"
			  d="M10,5.264c-2.612,0-4.736,2.125-4.736,4.735c0,2.612,2.125,4.736,4.736,4.736c2.611,0,4.735-2.124,4.735-4.736 C14.734,7.389,12.61,5.264,10,5.264z M10,12.735c-1.509,0-2.736-1.228-2.736-2.736S8.491,7.264,10,7.264 c1.508,0,2.735,1.227,2.735,2.735S11.508,12.735,10,12.735z"/>
		<circle class="st0" fill="#FFFFFF" cx="15.787" cy="4.211"
				r="1.052"/>
														</svg>
</template>

<script>
    export default {}
</script>